module.exports = __webpack_public_path__ + "static/media/pool.d987087e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/pool.svg
// module id = 1437
// module chunks = 0